import Dropkick from 'dropkickjs'

export default function(input) {
  new Dropkick(input, {
    mobile: false,
    // open: toggleCollapse.bind(null, true),
    // close: toggleCollapse.bind(null, false),
    change: () => {
      const event = document.createEvent('Event')
      event.initEvent('input', true, true)
      input.dispatchEvent(event)
    },
  })
}
